module.exports = __webpack_public_path__ + "img/Fireplace Insert.64312631.jpg";